const BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE = 'data-ws-block-template-dependency';

export default {
  BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE,
};
